import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/provider-search/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
